module.exports = __webpack_public_path__ + "51edd89b3c6336d2205e041ab90890bf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/11_A#2.mp3
// module id = 69
// module chunks = 0